import { render, staticRenderFns } from "./_.vue?vue&type=template&id=b086fe1c&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginForm: require('/app/components/auth/LoginForm.vue').default,ArticlesPage: require('/app/components/article/ArticlesPage.vue').default,ArticleContent: require('/app/components/article/ArticleContent.vue').default})
